













































import { Vue, Component, Prop, Watch, Emit } from "vue-property-decorator";

import THREE from 'src/misc/external/three';
import XLoader from 'src/misc/external/XFileLoader';
import _ from 'lodash';
import lru from 'lru-cache';

import Worker from '../x-loader.worker.js';


@Component
export default class BoxViewWrapperObject extends Vue {
  $refs: {
    rendererRef: HTMLElement
  }


  width = 490;
  height = 340;
  sceneWidth = 2.2;
  sceneHeight = 0.71;
  scene = new THREE.Scene();
  cameraFactor = 950;
  camera = new THREE.OrthographicCamera( this.width / - this.cameraFactor, this.width / this.cameraFactor, this.height / this.cameraFactor, this.height / - this.cameraFactor, 0.01, 100 );
  renderer = new THREE.WebGLRenderer({ antialias: true });

  startX = 0;
  startY = 0;
  worker: Worker = null;
  meshCache = lru({
    max: 14
  });

  renderedMeshFileUrls = [];

  constructor() {
    super();

    try {
      this.worker = new Worker();
      this.worker.addEventListener("message", this.onLoadedMesh);
    } catch (e) {
      console.error(`Unable to configure background worker`, e);
      this.worker = null;
    }

  }

  get boards() {
    return this.$store.state.currentProject.boards;
  }

  get box() {
    return this.$store.state.box;
  }

  get meshFileUrls() {
    return this.$store.getters.getMeshFileUrls;
  }

  get appMenuMini() {
    return this.$store.state.appMenuMini;
  }

  get card() {
    return this.$store.getters.getCard('GraphsCard');
  }

  @Watch('meshFileUrls')
  onMeshFileUrlsChanged() {
    if (_.isEqual(this.renderedMeshFileUrls, this.meshFileUrls))
      return;

    this.renderedMeshFileUrls = this.meshFileUrls;
    this.loadBoxes();
    this.handleResizeDelayed();
  }

  @Watch('appMenuMini')
  onAppMenuMiniChanged() {
    this.handleResizeDelayed();
  }

  @Watch('card', { deep: true })
  onCardChanged() {
    this.handleResizeDelayed();
  }

  positionBoxes() {
    if ( this.scene.children.length == 0 )
      return;

    let numBoxes = this.meshFileUrls.length;

    const firstBox = this.scene.children[0];
    // const firstGeom = (firstBox.children[0] as THREE.Mesh).geometry;
    const firstGeom = (firstBox as THREE.Mesh).geometry;
    firstGeom.computeBoundingBox();
    let bb = firstGeom.boundingBox;
    let dx = bb.max.x-bb.min.x;
    let dy = bb.max.y-bb.min.y; // y is up!
    let dz = bb.max.z-bb.min.z;
    let paddingAround = Math.sqrt(  dx*dx + dz*dz ) * 1.1;

    this.sceneWidth  = numBoxes * paddingAround;

    this.sceneHeight  = Math.sqrt( dx*dx + dy*dy + dz*dz);

    const ratio3D = this.sceneWidth / this.sceneHeight;
    const ratioPix = this.width / this.height;

    if ( ratio3D > ratioPix )
    {
      this.sceneHeight = this.sceneWidth / ratioPix; // make scene higher to align boxes with description
    }
    else
    {
      let wantedWidth = this.sceneHeight * this.width / this.height;
      paddingAround = wantedWidth / numBoxes
      this.sceneWidth  = numBoxes * paddingAround;
    }

    let leftEdge =  -paddingAround * (numBoxes - 1) / 2;
    for ( let i = 0; i < this.scene.children.length; ++i ) {
      var child = this.scene.children[i];

      if ( child instanceof THREE.Mesh ) {

        child.rotation.x = 0.4;
        child.rotation.y = 0.5;
        child.position.x = leftEdge + child.index * paddingAround;
      }

    }

    this.renderView();
  }

  onLoadedMesh(event) {
    const { url, geometries } = event.data;
    const index = this.meshFileUrls.findIndex( meshUrl => meshUrl == url );

    if (index == -1) {
      // Not relevant any more.
      return;
    }

    if (geometries == null) {
      this.$store.commit('meshFileUrlNotFound', url);
      return;
    }

    // var jsonLoader = new THREE.JSONLoader();
    var loader = new THREE.BufferGeometryLoader();
    var material = new THREE.MeshBasicMaterial({ vertexColors: THREE.VertexColors, side: THREE.FrontSide });

    let meshList = [];
    for (const g of geometries) {
      const geometry = loader.parse(g);

      const mesh = new THREE.Mesh(geometry, material);
      mesh.geometry.center();
      mesh.index = index;

      this.scene.add(mesh);
      meshList.push(mesh);
    }

    console.log(`Added mesh ${index} from url ${url}`);
    this.meshCache.set(url, meshList);

    this.handleResize();
  }

  loadMeshFromCache(url) {
    const meshList = this.meshCache.get(url);
    const index = this.meshFileUrls.findIndex( meshUrl => meshUrl == url );

    if (meshList) {
      console.log(`Found mesh ${url} in cache`);
      for (const mesh of meshList) {
        this.scene.add(mesh);
        mesh.geometry.center();
        mesh.index = index;
      }
      return true;
    } else {
      return false;
    }
  }

  loadBoxes() {
    this.scene.remove.apply(this.scene, this.scene.children);

    if (this.worker) {
      this.loadBoxesUsingWebWorker();
    } else {
      this.loadBoxesLocal();
    }

    this.handleResize();
  }

  loadBoxesUsingWebWorker() {
    for (const url of this.meshFileUrls) {
      if (!this.loadMeshFromCache(url)) {
        this.worker.postMessage({ url: url });
      }
    }
  }

  loadBoxesLocal() {
    var texloader = new THREE.TextureLoader();
    var material = new THREE.MeshBasicMaterial({ vertexColors: THREE.VertexColors });

    var onProgress = (xhr) => {
      if (xhr.lengthComputable) {
        var percentComplete = xhr.loaded / xhr.total * 100;
        console.log(Math.round(percentComplete) + '% downloaded');
      }
    };

    let numBoxes = this.meshFileUrls.length;

    for (let i = 0; i < numBoxes; i++) {
      var manager = new THREE.LoadingManager();
      var loader = new XLoader(manager, texloader);

      let meshList = [];

      const url = this.meshFileUrls[i];

      if (this.loadMeshFromCache(url)) {
        continue;
      }

      loader.load([url], (object) => {
        for (let j = 0; j < object.models.length; j++) {
          var model = object.models[j];

          this.scene.add(model);

          model.traverse( function ( child ) {
            meshList.push(child);
            if ( child instanceof THREE.Mesh ) {
              child.material = material;
              child.geometry.center();
              child.index = i;
            }
          });
        }

        this.meshCache.set(url, meshList);

        this.handleResize();
        object = null;
      }, onProgress, () => {
        this.$store.commit('meshFileUrlNotFound', url);
      });
    }


  }

  created() {
    this.renderer.setSize( this.width, this.height );
    this.renderer.setClearColor( 0xffffff, 1 );

    this.camera.position.z = 2;

    this.loadBoxes();

  }

  mounted() {
    window.addEventListener('resize', this.handleResize);
    this.$refs.rendererRef.appendChild(this.renderer.domElement);
    this.$refs.rendererRef.addEventListener( 'mousedown', this.handleMouseDown, false );

    this.positionBoxes();

    this.handleResizeDelayed();
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  }

  renderView() {
    this.renderer.render( this.scene, this.camera );
  }

  handleResizeDelayed() {
    setTimeout(() => {
      this.handleResize();
    }, 200);
  }

  handleResize() {
    if (!this.$refs.rendererRef) {
      return;
    }

    this.width = this.$refs.rendererRef.clientWidth;
    this.height = 340;

    this.positionBoxes();

    this.cameraFactor = Math.min(this.width / this.sceneWidth, this.height / this.sceneHeight);

    this.renderer.setSize( this.width, this.height );
    this.camera.left   = this.width  / -2;
    this.camera.right  = this.width  /  2;
    this.camera.top    = this.height /  2;
    this.camera.bottom = this.height / -2;
    this.camera.zoom = this.cameraFactor;
    this.camera.updateProjectionMatrix();

    this.renderView();
  }

  handleMouseDown(event) {
    event.preventDefault();

    if (event.button == 0) { // Left button
      this.startX = event.clientX;
      this.startY = event.clientY;
      document.addEventListener( 'mousemove', this.handleMouseMove, false );
      document.addEventListener( 'mouseup',   this.handleMouseUp,   false );
    }
  }

  handleMouseMove(event) {
    event.preventDefault();

    let endX = event.clientX;
    let endY = event.clientY;

    let deltaX = endX - this.startX;
    let deltaY = endY - this.startY;

    this.scene.traverse( function ( child ) {
      if ( child instanceof THREE.Mesh ) {
        child.rotation.x += deltaY * 0.01;
        child.rotation.y += deltaX * 0.01;
      }
    });

    this.renderView();

    this.startX = endX;
    this.startY = endY;
  }

  handleMouseUp(event) {
    document.removeEventListener( 'mousemove', this.handleMouseMove, false );
    document.removeEventListener( 'mouseup',   this.handleMouseUp,   false );
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/BoxViewWrapperObject.vue